import React from 'react';
import Icon from 'components/Icon';
import { IconType } from 'components/Icon/constants';
import * as Constants from 'const';
import styles from '../styles.module.scss';

type Props = {
  entityType: string;
  showIconComponent: boolean;
  dataTestId: string;
};

export const EntityTypeIcon = ({ entityType, showIconComponent, dataTestId }: Props): JSX.Element | null => {

  if (!showIconComponent) {
    return null;
  }
  let component: JSX.Element | null = null;

  switch (entityType) {
    case Constants.EntityType.TEXT:
      component = <Icon type={ IconType.TEXT } size="badge-sm" color="primary" />;
      break;
    case Constants.EntityType.IMAGE:
      component = <Icon type={ IconType.IMAGE } size="badge-sm" color="primary" />;
      break;
    case Constants.EntityType.REFERENCE_CITATION:
      component = <Icon type={ IconType.REFERENCE_CITATION } size="badge-sm" color="primary" />;
      break;
    case Constants.EntityType.LAYOUT:
    case Constants.EntityType.GROUP_LAYOUT:
      component = <Icon type={ IconType.LAYOUT } size="badge-sm" color="primary" />;
      break;
    default:
      component = null;
  }

  return (
    <div className={styles.iconHighlight} data-testid={`${dataTestId}-info-iconHighlight`}>
      {component}
    </div>
  );

};
